import { render, staticRenderFns } from "./BAddVacation.vue?vue&type=template&id=378e3899"
import script from "./BAddVacation.vue?vue&type=script&lang=js"
export * from "./BAddVacation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports